'use strict';

module.exports = function (darc) {
  darc.addOperation({
    name: 'all',
    args: [],
    description: '',
    inputs: 'T',
    outputs: 'T',
    requires: {
      resolve: {
        indexes: true
      }
    },
    use: function use(cursor) {
      while (cursor && cursor.$.indexes && cursor.$.indexes !== undefined) {
        cursor = cursor.$.parent;
      }

      return cursor;
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9vcHMvYWxsLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJkYXJjIiwiYWRkT3BlcmF0aW9uIiwibmFtZSIsImFyZ3MiLCJkZXNjcmlwdGlvbiIsImlucHV0cyIsIm91dHB1dHMiLCJyZXF1aXJlcyIsInJlc29sdmUiLCJpbmRleGVzIiwidXNlIiwiY3Vyc29yIiwiJCIsInVuZGVmaW5lZCIsInBhcmVudCJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBRUFBLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsSUFBVixFQUFpQjtBQUVqQ0EsT0FBS0MsWUFBTCxDQUFtQjtBQUVsQkMsVUFBTSxLQUZZO0FBR2xCQyxVQUFNLEVBSFk7QUFJbEJDLGlCQUFhLEVBSks7QUFLbEJDLFlBQVEsR0FMVTtBQU1sQkMsYUFBUyxHQU5TO0FBT2xCQyxjQUFVO0FBRVRDLGVBQVM7QUFFUkMsaUJBQVM7QUFGRDtBQUZBLEtBUFE7QUFnQmxCQyxTQUFLLGFBQVVDLE1BQVYsRUFBbUI7QUFFdkIsYUFBUUEsVUFBVUEsT0FBT0MsQ0FBUCxDQUFTSCxPQUFuQixJQUE4QkUsT0FBT0MsQ0FBUCxDQUFTSCxPQUFULEtBQXFCSSxTQUEzRCxFQUF1RTtBQUV0RUYsaUJBQVNBLE9BQU9DLENBQVAsQ0FBU0UsTUFBbEI7QUFFQTs7QUFFRCxhQUFPSCxNQUFQO0FBRUE7QUExQmlCLEdBQW5CO0FBOEJBLENBaENEIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCBkYXJjICkge1xuXG5cdGRhcmMuYWRkT3BlcmF0aW9uKCB7XG5cblx0XHRuYW1lOiAnYWxsJyxcblx0XHRhcmdzOiBbXSxcblx0XHRkZXNjcmlwdGlvbjogJycsXG5cdFx0aW5wdXRzOiAnVCcsXG5cdFx0b3V0cHV0czogJ1QnLFxuXHRcdHJlcXVpcmVzOiB7XG5cblx0XHRcdHJlc29sdmU6IHtcblxuXHRcdFx0XHRpbmRleGVzOiB0cnVlXG5cblx0XHRcdH1cblxuXHRcdH0sXG5cdFx0dXNlOiBmdW5jdGlvbiggY3Vyc29yICkge1xuXG5cdFx0XHR3aGlsZSAoIGN1cnNvciAmJiBjdXJzb3IuJC5pbmRleGVzICYmIGN1cnNvci4kLmluZGV4ZXMgIT09IHVuZGVmaW5lZCApIHtcblxuXHRcdFx0XHRjdXJzb3IgPSBjdXJzb3IuJC5wYXJlbnQ7XG5cblx0XHRcdH1cblxuXHRcdFx0cmV0dXJuIGN1cnNvcjtcblxuXHRcdH1cblxuXHR9ICk7XG5cbn07XG4iXX0=